// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--TlfHB","photo":"a10a3f92e9--photo--Sd2MB","cell":"a10a3f92e9--cell--YCooZ"};